module.exports = __webpack_public_path__ + "static/media/SabineBourgeois.d212caaa.mp4";